import { fetchAllSKU } from 'api/sku';

import { SkuType } from 'types/sku';

import { useMutation, useQuery } from 'react-query';

export const useSKU = (
  type: SkuType,
  washHubId?: string,
  siteId?: string,
  activeOnly?: 0 | 1,
  skipWashHub?: boolean,
) => {
  // activeOnly is part of the key: callers asking for active-only and for
  // all SKUs would otherwise share one cache entry and read each other's list.
  const queryKey = [
    `fetch-all-sku-select`,
    type,
    washHubId,
    siteId,
    Boolean(activeOnly),
    skipWashHub,
  ];

  const queryFn = () =>
    fetchAllSKU(type, washHubId, siteId, Boolean(activeOnly), skipWashHub);

  const options = {
    refetchOnMount: 'always' as any,
  };
  const query = useQuery(queryKey, queryFn, options);

  return query;
};

export const useSKUmtn = (
  type: SkuType,
  washHubId?: string,
  siteId?: string,
) => {
  const mutation = useMutation(() => fetchAllSKU(type, washHubId, siteId));

  return mutation;
};
